import Button from '@ui/button/Button';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import SubscribeForm from '@moncler/components/experience/SubscribeForm';
const CountDown = (props) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "button", onClick: (e) => {
                setIsOpen(true);
                props.designerName && analytics.geniusExperienceSignUpAction('start', props.designerName);
            }, cls: typeof props.classes === 'string' ? JSON.parse(props.classes) : props.classes, ariaHaspopup: "dialog" }, props.text || t('button.submit')),
        React.createElement(ModalDialog, { overlayClassName: "overlay-visible", className: classNames('countdown-modal', { black: props.blackVersion }), hideHeader: true, noPadding: true, isOpen: isOpen, onRequestClose: () => {
                !props.designerName && analytics.getNotificationModalAction(props.type, props.title, 'close');
                setIsOpen(false);
            }, contentLabel: t('label.notifyme') },
            React.createElement(SubscribeForm, Object.assign({}, props, { closeCallback: () => setIsOpen(false) }))),
        props.secondCtaLink && (React.createElement("a", { href: props.secondCtaLink, className: props.buttonClasses, "aria-describedby": props.uuid }, props.secondCtaText))));
};
export default CountDown;
